import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`notificacao-geral/adm?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`notificacao-geral/${id}`);
    },
    create(data){
        return Api().post(`notificacao-geral`, data);
    },
    update(data){
        return Api().put(`notificacao-geral/${data.id}`, data);
    },
    delete(id) {
      return Api().delete(`notificacao-geral/${id}`);
    }
}